<ion-app [class.minimize-modal]="minimizeModal$ | async">
  <ion-router-outlet *ngIf="!isIframe">
    <div class="loader-container" *ngIf="isShownAppSpinner$ | async">
      <div class="loader"></div>
    </div>
  </ion-router-outlet>
  <div class="minimized-modal modal-wrapper" *ngIf="minimizeModal$ | async as minimizeModal">
    <div class="modal">
      <div class="inner">
        <div class="buttons">
          <div class="title">{{minimizeModal}}</div>
          <div class="display-button">
            <ion-button class="btn" fill="clear" (click)="displayModal()" title="Expand modal">
              <ion-icon name="expand-outline"></ion-icon>
            </ion-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-app>
